import partnerLogoFiles from '../../public/img/partners';
import { PartnerKey } from './constants';

// Moved this out of constants.ts to reduce initial chunk size: all partner images were included

export type PartnerData = {
  key: PartnerKey;
  name: string;
  logo: string;
  hide?: boolean;
  logoHeight?: string;
  logoWidth?: string; // Used by PartnerSlider
  officeId?: string; // If we want to add customer requests to Samen
};

// Importing all partner logos is bad for bundle size
// I've already moved this outside of the common constants file, so it's not too bad now
export const DEB_PARTNERS: PartnerData[] = [
  {
    key: PartnerKey.BudgetThuis,
    name: 'Budget Thuis',
    logo: partnerLogoFiles.BudgetThuis,
    logoHeight: '2.5em',
    logoWidth: '120px',
  },
  {
    key: PartnerKey.GavoorA,
    name: 'GavoorA',
    logo: partnerLogoFiles.GavoorA,
    logoWidth: '120px',
    logoHeight: '90px',
  },
  {
    key: PartnerKey.Hypotheekshop,
    name: 'De Hypotheekshop',
    logo: partnerLogoFiles.Hypotheekshop,
    logoWidth: '120px',
  },
  {
    key: PartnerKey.Hypokeur,
    name: 'Hypokeur',
    logo: partnerLogoFiles.Hypokeur,
    logoWidth: '150px',
  },
  {
    key: PartnerKey.HuisHypotheek,
    name: 'Huis & Hypotheek',
    logo: partnerLogoFiles.HuisHypotheek,
    logoWidth: '150px',
  },
  {
    key: PartnerKey.ImpactHypotheken,
    name: 'Impact Hypotheken',
    logo: partnerLogoFiles.ImpactHypotheken,
    logoWidth: '150px',
  },
  {
    key: PartnerKey.Lot,
    name: 'Lot Hypotheken',
    logo: partnerLogoFiles.Lot,
    logoWidth: '120px',
  },
  {
    key: PartnerKey.MUNT,
    name: 'MUNT Hypotheken',
    logo: partnerLogoFiles.MUNT,
    logoWidth: '120px',
  },
  {
    key: PartnerKey.NBG,
    name: 'NBG',
    logo: partnerLogoFiles.NBG,
    logoWidth: '120px',
  },
  {
    key: PartnerKey.Triodos,
    name: 'Triodos Bank',
    logo: partnerLogoFiles.Triodos,
    logoWidth: '180px',
  },
  {
    key: PartnerKey.VanBruggen,
    name: 'Van Bruggen Adviesgroep',
    logo: partnerLogoFiles.VanBruggen,
    logoWidth: '150px',
  },
  {
    key: PartnerKey.Veldsink,
    name: 'Veldsink Advies',
    logo: partnerLogoFiles.Veldsink,
    logoWidth: '180px',
    officeId: '',
  },
  {
    key: PartnerKey.Viisi,
    name: 'Viisi',
    logo: partnerLogoFiles.Viisi,
    logoWidth: '150px',
  },
  {
    key: PartnerKey.HpHypotheken,
    name: '100% Hypotheken',
    logo: partnerLogoFiles.HPHypotheken,
    logoWidth: '150px',
  },
  {
    key: PartnerKey.Frits,
    name: 'Frits',
    logo: partnerLogoFiles.Frits,
    logoWidth: '150px',
    officeId: '634eaf16093fbe4903073256',
  },
  {
    key: PartnerKey.HypotheekVisie,
    name: 'Hypotheek Visie',
    logo: partnerLogoFiles.HypotheekVisie,
    logoWidth: '180px',
  },
  {
    key: PartnerKey.Ennatuurlijk,
    name: 'Ennatuurlijk',
    logo: partnerLogoFiles.Ennatuurlijk,
    logoWidth: '150px',
    hide: true,
  },
  {
    key: PartnerKey.GroeneHart,
    name: 'Groene Hart Hypotheken',
    logo: partnerLogoFiles.GroeneHart,
    logoWidth: '180px',
  },
  {
    key: PartnerKey.Venn,
    name: 'Venn Hypotheken',
    logo: partnerLogoFiles.Venn,
    logoWidth: '150px',
  },
  {
    key: PartnerKey.Verbrugge,
    name: 'Verbrugge',
    logo: partnerLogoFiles.Verbrugge,
    logoWidth: '180px',
  },
];
